import Vue from 'vue'
import VueI18n from 'vue-i18n'

import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

import moment from 'moment'
import UUID from 'vue-uuid';
import * as VueGoogleMaps from 'vue2-google-maps-withscopedautocomp'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import http from './plugins/api';

//import config
import {DEVConfig as firebaseConfig } from "./config";

Vue.config.productionTip = false

// Initialize Firebase app

//for production build
if (process.env.NODE_ENV == 'production') {
    firebase.initializeApp(firebaseConfig);
}

//for develpment, firebase available under window.fbApp
if (process.env.NODE_ENV !== 'production') {
    window.fbApp = ""

    if (window.fbApp == "")
        window.fbApp = firebase.initializeApp(firebaseConfig);
}

moment.locale('de');

Vue.use(VueI18n);

const messages = {
    de: {
        app: {
            title: 'Neophyten-GIS',
            signIn: 'Anmelden',
            signOut: 'Abmelden',
            apply: 'Übernehmen',
            save: 'Speichern',
            cancel: 'Abbruch',
            email: 'E-Mail',
            export: 'Export',
            password: 'Passwort',
            role: 'Rolle',
            ok: 'Ok',
            all: 'Alle',
            my: 'Offen',
        },
        key: {
            mapSettings: 'Karte Einstellungen',
            mapFilter: 'Filter',
            mapFilterSelected: ' - {0} von {1} ausgewählt',
            mapTypes: 'Kartentypen',
            mapTypeHybrid: 'Hybrid',
            mapTypeTerrain: 'Gelände',
            mapTypeRoadmap: 'Straße',
            mapTypeSatellite: 'Satellit',
            mapMarker: 'Pin',
            mapCircle: 'Kreis',
            mapPolygon: 'Polygon',
            others: 'andere',
            location: 'Ort',
            propagation: 'Verbreitung',
            piece: 'Stk',

            properties: 'Eigenschaften',
            neophyteName: 'Name des Neophyt',
            scientificName: 'Wissenschaftlicher Name',
            mixUps: 'Verwechslungsgefahr',
            images: 'Bilder',
            briefing: 'Steckbrief',
            editor: 'Editor',
            preview: 'Vorschau',
            color: 'Farbe',
            map: 'Karte',

            firstName: 'Vorname',
            lastName: 'Nachname',
            mobilePhoneNumber: 'Mobiltelefon',
            province: 'Bundesland',
            pool: 'MR Nummer',

            surveys: 'Erhebungen',
            plants: 'Pflanzen',
            number: 'Anzahl in Stück',
            area: 'Fläche in m²',
            total: 'Gesamt',

            neophyte: 'Neophyt',
            stadium: 'Vegetationsstadium',
            areaOfPlants: 'Pflanzenfläche',
            areaOfPlantsUnit: 'm²',
            numberOfPlants: 'Pflanzenzahl',
            numberOfPlantsUnit: 'Stk',
            contractor: 'Dienstleister',
            propertyNumber: 'Grundstücksnummer',
            customer: 'Kunde',
            actionType: 'Maßnahme',
            action: 'Durchgeführte Aktion',
            amountValue: 'Erntemenge',
            amountUnit: 'Einheit',
            date: 'Erhebungsdatum',
            timeStart: 'Startzeit der Erhebung',
            timeEnd: 'Endzeit der Erhebung',
            note: 'Notiz',

            deletePlantTitle: 'Neophyt löschen',
            deletePlantText: 'Sind Sie sicher, dass Sie den Neophyt - {0} - löschen wollen?',
            deleteSurveyTitle: 'Erhebung löschen',
            deleteSurveyText: 'Sind Sie sicher, dass Sie die Erhebung - {0} - löschen wollen?',
            deleteUserTitle: 'Benutzer löschen',
            deleteUserText: 'Sind Sie sicher, dass Sie den Benutzer - {0} - löschen wollen?',
            locatePlantText: 'Wählen Sie den Ort des Neophyt auf der Karte aus',

            emailRequired: 'E-mail Adresse wird benötigt',
            emailInvalid: 'E-mail Adresse ist ungültig',
            passwordRequired: 'Passwort wird benötigt',
            passwordInvalid: 'Passwort ist ungültig; es muss mindestens 6 Zeichen enthalten',
            firstNameRequired: 'Vorname wird benötigt',
            lastNameRequired: 'Nachname wird benötigt',
            mobilePhoneRequired: 'Mobiltelefon Nummer wird benötigt',
            poolRequired: 'MR Nummer wird benötigt',
            poolInvalid: 'MR Nummer ist ungültig; sie besteht aus 3 Zahlen',

            month0: 'Jan',
            month1: 'Feb',
            month2: 'Mar',
            month3: 'Apr',
            month4: 'Mai',
            month5: 'Jun',
            month6: 'Jul',
            month7: 'Aug',
            month8: 'Sep',
            month9: 'Okt',
            month10: 'Nov',
            month11: 'Dez',

            role1: 'Superadmin',
            role2: 'Admin',
            role3: 'Dienstleister',

            details: 'Details',
            overview: 'Übersicht',
        },
        nav: {
            home: 'Karte',
            plants: 'Neophyten',
            plant: 'Neophyt',
            surveys: 'Erhebungen',
            survey: 'Erhebung',
            users: 'Benutzer',
            report: 'Bericht',
            imprint: 'Impressum'
        }
    },
    en: {
        app: {
            title: 'Neophyten-GIS',
            signIn: 'Sign-in',
            signOut: 'Sing-out',
            apply: 'Apply',
            save: 'Save',
            cancel: 'Cancel',
            email: 'E-mail',
            export: 'Export',
            password: 'Password',
            role: 'Role',
            ok: 'Ok',
            all: 'All',
            my: 'My',
        },
        key: {
            mapSettings: 'Map Settings',
            mapFilter: 'Filter',
            mapFilterSelected: ' - {0} of {1} selected',
            mapTypes: 'Map Types',
            mapTypeHybrid: 'Hybrid',
            mapTypeTerrain: 'Terrain',
            mapTypeRoadmap: 'Roadmap',
            mapTypeSatellite: 'Satellite',
            mapMarker: 'Marker',
            mapCircle: 'Circle',
            mapPolygon: 'Polygon',
            others: 'others',
            location: 'Location',
            propagation: 'Propagation',
            piece: 'pc',

            properties: 'Properties',
            neophyteName: 'Name of Neophyte',
            scientificName: 'Scientific Name',
            mixUps: 'Mix-ups',
            images: 'Images',
            briefing: 'Briefing',
            editor: 'Editor',
            preview: 'Preview',
            color: 'Color',
            map: 'Map',

            firstName: 'First Name',
            lastName: 'Last Name',
            mobilePhoneNumber: 'Mobile Phone',
            province: 'Province',
            pool: 'Pool',

            surveys: 'Surveys',
            plants: 'Plants',
            number: 'Number',
            area: 'Area',
            total: 'Total',

            neophyte: 'Neophyte',
            stadium: 'Stadium',
            areaOfPlants: 'Plant area',
            areaOfPlantsUnit: 'sm',
            numberOfPlants: 'Plant count',
            numberOfPlantsUnit: 'Count',
            contractor: 'Contractor',
            propertyNumber: 'Property id number',
            customer: 'Customer',
            actionType: 'Action',
            action: 'Executed action',
            amountValue: 'Amount',
            amountUnit: 'Unit',
            date: 'Survey date',
            timeStart: 'Start Date',
            timeEnd: 'End Date',
            note: 'Note',

            deletePlantTitle: 'Delete neophyte',
            deletePlantText: 'Do you really want to delete the neophyte: {0}?',
            deleteSurveyTitle: 'Delete survey',
            deleteSurveyText: 'Do you really want to delete the survey: {0}?',
            deleteUserTitle: 'Delete user',
            deleteUserText: 'Do you really want to delete the user: {0}?',
            locatePlantText: 'Select the place of the Neophyte at the map',

            emailRequired: 'E-mail is required',
            emailInvalid: 'E-mail is invalid',
            passwordRequired: 'Password is required',
            passwordInvalid: 'Password is invalid; it must be greater than 6 characters',
            firstNameRequired: 'First name is required',
            lastNameRequired: 'Last name is required',
            mobilePhoneRequired: 'Mobile phone is required',
            poolRequired: 'Pool is required',
            poolInvalid: 'Pool is invalid; it must be equal to 3 digits',

            month0: 'Jan',
            month1: 'Feb',
            month2: 'Mar',
            month3: 'Apr',
            month4: 'May',
            month5: 'Jun',
            month6: 'Jul',
            month7: 'Aug',
            month8: 'Sep',
            month9: 'Oct',
            month10: 'Nov',
            month11: 'Dec',

            role1: 'Superadmin',
            role2: 'Admin',
            role3: 'Contractor',

            details: 'Details',
            overview: 'Overview',
        },
        nav: {
            home: 'Map',
            plants: 'Neophytes',
            plant: 'Neophyte',
            surveys: 'Surveys',
            survey: 'Survey',
            users: 'Users',
            report: 'Report',
            imprint: 'Imprint'
        }
    }
}

const i18n = new VueI18n({
    locale: 'de', // set locale
    fallbackLocale: 'en',
    messages // set locale messages
})

Vue.use(UUID);

Vue.use(VueGoogleMaps, {
    load: {
        // see https://developers.google.com/maps/documentation/javascript/libraries
        libraries: ['places', 'geometry'],
        key: 'AIzaSyC7wwe9JXEM1ljP7QqwuC8FbK_Vih8OGxQ',

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
})

let app = null;

// Wait for Firebase Auth to init before creating the app
firebase.auth().onAuthStateChanged((userCredential) => {

    if (userCredential) {
        // Auto sign-in at Firebase Auth
        store.dispatch('autoSignIn', userCredential).then(() => {
            console.log(`Auto sign-in: ${userCredential.email}`)

            // Load user-profile
            store.dispatch('loadUserProfile', userCredential.email).then(() => {
                console.log(`Load user-profile: ${userCredential.email}`)
            })
        })
    }

    store.dispatch('trackPosition').then(() => {
        console.log(`Track position`)
    })

    // Once app is created, do not create it again
    if (!app) {
        /* eslint-disable no-new */
        Vue.prototype.$http = http;

        app = new Vue({
            i18n,
            router,
            store,
            vuetify,
            render: h => h(App)
        }).$mount('#app');
    }
});
